import type { CSSProperties, ReactNode } from 'react'
import { Icon, type IconName } from '@/components/icons/icon'
import { cn } from '@/lib/utils'

/** The list the rows sit in (`.attn`). */
export function AttentionList({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('attn', className)}>{children}</div>
}

interface AttentionRowProps {
  icon: IconName
  /** `acc` costs money or a customer if ignored (Ember); `warn` needs a look; `act` informational. */
  tone: 'acc' | 'warn' | 'act'
  title: ReactNode
  /** One line under the title. */
  body?: ReactNode
  /** Badges under the body (`.attn-meta`), before the time. */
  meta?: ReactNode
  /** The time, at the end of the meta row (`.when`). */
  when?: ReactNode
  /** The one obvious action, on the right (`.attn-act`). */
  actions?: ReactNode
  className?: string
  style?: CSSProperties
}

/** One thing that needs someone (`.attn-row`): tinted icon, title, body, one action. */
export function AttentionRow({ icon, tone, title, body, meta, when, actions, className, style }: AttentionRowProps) {
  return (
    <div className={cn('attn-row', className)} style={style}>
      <span className={`attn-ic ai-${tone}`} aria-hidden="true">
        <Icon name={icon} />
      </span>
      <div className="attn-body">
        <b>{title}</b>
        {body ? <p>{body}</p> : null}
        {meta || when ? (
          <div className="attn-meta">
            {meta}
            {when ? <span className="when">{when}</span> : null}
          </div>
        ) : null}
      </div>
      {actions ? <div className="attn-act">{actions}</div> : null}
    </div>
  )
}
